import {NgModule} from "@angular/core";
import {SharedModule} from "../../shared.module";
import {SkinAnalyzerComponent} from "./skin-analyzer.component";
import {ProductResultsCardModule} from "../product/results/product-results-card.module";

@NgModule({
    imports: [
        SharedModule,
        ProductResultsCardModule,
    ],
    providers: [],
    exports: [
        SkinAnalyzerComponent,
    ],
    declarations: [
        SkinAnalyzerComponent,
    ]
})
export class SkinAnalyzerModule { }
